


















import { Component, Prop, Vue } from 'vue-property-decorator';
import { TagCategoryStateModule, TagCategoryGroupedTagList } from '@/store';
import { TagCategoryModel } from '@/type/api';

@Component<Tags>({
  components: {},
})
export default class Tags extends Vue {
  // PROPS
  @Prop({
    type: Function,
    default: () => {
      /** NP */
    },
  })
  handleClickAddTag!: (tag: TagCategoryModel.Read.Response.List) => void;

  // FIELDS
  TagCategoryStateModule = TagCategoryStateModule;
  isProcessing = false;

  // MUTATIONS
  get tagDefs() {
    return TagCategoryStateModule.sortedTagDefs;
  }
}
